import { CloseBtn as e, Counter as t, SectionLabel as n, TopBarCenter as r, TopBarEnd as i, TopBarGrid as a, TopBarWrapper as o } from "../styles.mjs";
import "react";
import { useTranslation as s } from "@maat/store-i18n";
import { jsx as c, jsxs as l } from "react/jsx-runtime";
import { X as u } from "lucide-react";
//#region src/components/FullscreenGallery/components/GalleryTopBar.tsx
var d = ({ currentIndex: d, totalImages: f, onClose: p, label: m, actions: h }) => {
	let { t: g } = s("ds");
	return !m && !h ? /* @__PURE__ */ l(o, { children: [/* @__PURE__ */ l(t, { children: [
		d + 1,
		" / ",
		f
	] }), /* @__PURE__ */ c(e, {
		onClick: p,
		"aria-label": g("ds:gallery.close"),
		children: /* @__PURE__ */ c(u, { size: 20 })
	})] }) : /* @__PURE__ */ l(a, { children: [
		/* @__PURE__ */ c("div", { children: /* @__PURE__ */ c(e, {
			onClick: p,
			"aria-label": g("ds:gallery.close"),
			children: /* @__PURE__ */ c(u, { size: 20 })
		}) }),
		/* @__PURE__ */ l(r, { children: [m && /* @__PURE__ */ c(n, { children: m }), /* @__PURE__ */ c(t, { children: g("ds:gallery.counter", {
			index: d + 1,
			total: f
		}) })] }),
		/* @__PURE__ */ c(i, { children: h })
	] });
};
//#endregion
export { d as GalleryTopBar };
